import { Component, OnInit, RootRenderer, ViewChild } from '@angular/core';
import { Student } from '../../students/shared/student.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Program } from '../../programs/shared/program.model';
import { StudentService } from '../../students/shared/student.service';
import { ProgramService } from '../../programs/shared/program.service';
import { RequestService } from '../shared/request.service';
import { College } from '../shared/model/college.model';
import { Request } from '../shared/model/request.model';

import { SubjectsComponent } from '../subjects/subjects.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ConfirmationDialogComponent } from 'src/app/core/modal/confirmation-dialog/confirmation-dialog.component';
import { SubjectMatter } from '../shared/subject-matter.model';
import { SubjectsHistoryComponent } from '../subjects-history/subjects-history.component';
import { Testing } from '../shared/model/testing.model';
import { SubjectsProficiencyComponent } from '../subjects-proficiency/subjects-proficiency.component';
import { SubjectProficiency } from '../shared/model/subject-proficiency.model';
import { Location } from '@angular/common';
import { ViewRequestsComponent } from '../../reports/view-requests/view-requests.component';
import { RequestsStudentComponent } from '../../reports/requests-student/requests-student.component';
import { RequestsStudentDialogComponent } from 'src/app/core/modal/requests-student-dialog/requests-student-dialog.component';
import { ViewRequest } from '../../reports/shared/view-request.model';
import { ReportsService } from '../../reports/shared/reports.service';

@Component({
  selector: 'app-request-subjects',
  templateUrl: './request-subjects.component.html',
  styleUrls: ['./request-subjects.component.scss']
})
export class RequestSubjectsComponent implements OnInit {
  private mensajeDependecia =
    'Su dependencia / programa aún no está autorizado ' +
    'para realizar solicitudes de reconocimiento u homologación de materia';

  @ViewChild(SubjectsComponent) subjects: SubjectsComponent;
  @ViewChild(SubjectsHistoryComponent)
  subjectsHistory: SubjectsHistoryComponent;
  @ViewChild(SubjectsProficiencyComponent)
  subjectsProficiency: SubjectsProficiencyComponent;
  student: Student;
  typeRequest: number;
  program: Program;
  documents: DocumentType[];
  colleges: College[];
  semesters: String[];
  subjectsMatter: SubjectMatter[];
  testing: Testing[];
  messageError: String = '';
  messageValidation: String = '';
  isRegular = true;
  enabledBack = false;
  tittleDocument =
    'Documentación requerida para entregar en la unidad académica';
  requestsStudent: ViewRequest[];
  testRequests: ViewRequest[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private requestService: RequestService,
    private location: Location,
    private studentService: StudentService,
    private programService: ProgramService,
    private dialog: MatDialog,
    private reportService: ReportsService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.getRequestsStudent();
      this.getValTestRequest();
      const program = params['programa'];
      this.typeRequest = params['tipo'];
      if (!params['enableBack']) {
        this.enabledBack = true;
      }

      if (this.typeRequest > 2) {
        this.isRegular = false;
      }
      const cedula = localStorage.getItem('cedula');
      this.programService
        .isFacultyAvaible(cedula, program)
        .subscribe(result => {
          if (result.data) {
            if (this.typeRequest.toString() === '1') {
              this.initialValueComponentHistory(cedula, program);
            } else if (this.typeRequest.toString() === '4') {
              this.initialValueComponentTesting(
                cedula,
                program,
                this.typeRequest
              );
            } else {
              this.initialValueComponent(cedula, program, this.typeRequest);
            }
          } else {
            const parameters = {
              tipo: 'error',
              mensaje: this.mensajeDependecia
            };
            this.router.navigate(['message'], { queryParams: parameters });
          }
        });
    });
  }
  back() {
    this.location.back();
  }
  sendRequest() {
    if (this.validateSubjects()) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        tittle: 'Mensaje Confirmación',
        message: '¿Esta seguro que desea enviar la Solicitud?'
      };
      dialogConfig.width = '30%';
      const dialogRef = this.dialog.open(
        ConfirmationDialogComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          this.generateRequest();
        }
      });
    } else {
      this.messageError =
        'Hay campos obligatorios vacios, por favor verifique la solicitud';
    }
  }

  generateRequest() {
    const requestSend = new Request();
    requestSend.cedula = this.student.cedula;
    requestSend.tipoSolicitud = this.typeRequest;
    requestSend.programa = this.program.codigo + '';
    requestSend.materias = this.subjects.subjects;
    this.requestService.savedRequest(requestSend).subscribe(result => {
      if (result.data === 'OK') {
        this.messageError = '';
        this.router.navigate(['solicitudes/registro-asignaturas/existoso'], {
          queryParams: { tipo: this.typeRequest }
        });
      } else {
        this.messageError = result.data as String;
      }
    });
  }

  sendRequestHistory() {
    if (this.validateSubjectsHistory()) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        tittle: 'Mensaje Confirmación',
        message: '¿Esta seguro que desea enviar la Solicitud?'
      };
      dialogConfig.width = '30%';
      const dialogRef = this.dialog.open(
        ConfirmationDialogComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          this.generateRequestHistory();
        }
      });
    } else {
      this.messageError =
        'Hay campos obligatorios vacios, por favor verifique la solicitud';
    }
  }

  generateRequestHistory() {
    this.messageError = '';
    const requestSend = new Request();
    requestSend.cedula = this.student.cedula;
    requestSend.tipoSolicitud = this.typeRequest;
    requestSend.programa = this.program.codigo + '';
    requestSend.materias = this.subjectsHistory.subjectsHistory;
    this.requestService.savedRequest(requestSend).subscribe(result => {
      if (result.data === 'OK') {
        this.messageError = '';
        const parameters = {
          tipo: 'info',
          mensaje: 'Solicitud enviada con éxito'
        };
        this.router.navigate(['message'], { queryParams: parameters });
      } else {
        this.messageError = result.data as String;
      }
    });
  }

  sendRequestProfi() {
    const validate = this.validateSubjectsProfi();
    if (validate === '') {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        tittle: 'Mensaje Confirmación',
        message: '¿Esta seguro que desea enviar la Solicitud?'
      };
      dialogConfig.width = '30%';
      const dialogRef = this.dialog.open(
        ConfirmationDialogComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          this.generateRequestProfi();
        }
      });
    } else {
      this.messageError = validate;
    }
  }

  generateRequestProfi() {
    this.messageError = '';
    const requestSend = new Request();
    let minRango = '';
    requestSend.cedula = this.student.cedula;
    requestSend.tipoSolicitud = this.typeRequest;
    requestSend.programa = this.program.codigo + '';
    requestSend.pruebasProficiencia = this.subjectsProficiency.subjectsProficiency.map(
      (subject: SubjectProficiency) => {
        const splitFile = subject.archivoAdjunto.split('.');
        const extension = splitFile[splitFile.length - 1];
        subject.archivoAdjunto = subject.pathArchivo + '.' + extension;
        const locaDate = subject.fecha.toLocaleString().split('/');
        const dia = Number(locaDate[0]) <= 9 ? '0' + locaDate[0] : locaDate[0];
        const mes = Number(locaDate[1]) <= 9 ? '0' + locaDate[1] : locaDate[1];
        const year = subject.fecha.getFullYear();
        subject.fechaPrueba = dia + '-' + mes + '-' + year;
        if (subject.puntaje.toString().search('.') === 1) {
          subject.puntaje = subject.puntaje.replace('.', ',');
        }

        minRango = subject.minRango.toLocaleString();
        if (minRango.search('.') === 1) {
          subject.puntaje = subject.puntaje.replace('.', ',');
        }
        return subject;
      }
    );
    this.requestService.savedRequestTesting(requestSend).subscribe(result => {
      if (result.data === 'OK') {
        this.messageError = '';
        this.router.navigate(['solicitudes/registro-asignaturas/existoso'], {
          queryParams: { tipo: this.typeRequest }
        });
      } else {
        this.messageError = result.data as String;
      }
    });
  }

  private validateSubjectsProfi(): String {
    let result = '';
    this.subjectsProficiency.subjectsProficiency.forEach(
      (valor, indice, array) => {
        if (
          !valor.idPrueba ||
          !valor.fecha ||
          !valor.puntaje ||
          !valor.archivoAdjunto ||
          !valor.entidad
        ) {
          result =
            'Hay campos obligatorios vacios, por favor verifique la solicitud';
          return;
        } else {
          if (parseFloat(valor.puntaje.toString()) < valor.minRango) {
            result = 'El puntaje ingresado es menor al mínimo permitido';
          } else if (parseFloat(valor.puntaje.toString()) > valor.maxRango) {
            result = 'El puntaje ingresado es mayor al máximo permitido';
          }
        }
        const fecha = new Date(valor.fecha);
        const fechaActual = new Date();
        if (fecha >= fechaActual) {
          result = 'La fecha presentación debe ser menor a la fecha actual';
        } else if (valor.vigencia !== undefined) {
          const ano = fechaActual.getFullYear() - fecha.getFullYear();
          let vigencia = 0;
          if (ano > 0) {
            vigencia = ano * 12;
          }
          vigencia =
            vigencia + fechaActual.getMonth() + 1 - fecha.getMonth() + 1;
          if (vigencia > valor.vigencia) {
            result =
              'La fecha de presentación de la prueba no esta en vigencia';
          }
        }

        // Validar por año
      }
    );
    return result;
  }

  clean() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      tittle: 'Mensaje Confirmación',
      message:
        'Recuerde perdera toda la información diligenciada ¿Esta seguro que desea limpiar el formulario?'
    };
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(
      ConfirmationDialogComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe(value => {
      if (value === 1) {
        this.messageError = '';
        if (this.subjects !== undefined) {
          this.subjects.clean();
        } else if (this.subjectsHistory !== undefined) {
          this.subjectsHistory.clean();
        } else {
          this.subjectsProficiency.clean();
        }
      }
    });
  }

  setMessage(message) {
    this.messageValidation = message;
  }

  validateLoadData(): boolean {
    return !this.student && !this.program && !this.documents;
  }

  private initialValueComponent(cedula, program, tipo) {
    this.getInforStudent(cedula, program);
    this.getListDocumentRequiered(tipo);
    this.getColleges();
    this.getSemestersByStudent(cedula);
  }

  private initialValueComponentHistory(cedula, program) {
    this.getInforStudent(cedula, program);
    this.getSubjectMatter(cedula, program);
  }

  private initialValueComponentTesting(cedula, program, tipo) {
    this.getListDocumentRequiered(tipo);
    this.getInforStudent(cedula, program);
    this.getTestings();
  }

  private getInforStudent(cedula, programa) {
    this.studentService
      .getInformatioStudentPrograms(cedula, programa)
      .subscribe(result => {
        if (result.data !== {}) {
          this.student = result.data.estudiante;
          this.program = result.data.programas[0];
        }
      });
  }

  private getListDocumentRequiered(tipo: String) {
    this.requestService.getTypesDocument(tipo).subscribe(result => {
      if (result.data !== {}) {
        this.tittleDocument = result.data.titulo;
        this.documents = result.data.documentos as DocumentType[];
      }
    });
  }

  private getColleges() {
    this.requestService.getColleges().subscribe(result => {
      if (result.data !== []) {
        this.colleges = result.data as College[];
      }
    });
  }

  private getSubjectMatter(cedula, programa) {
    this.studentService
      .getStudentRecords(cedula, programa, null)
      .subscribe(result => {
        if (result.data !== {}) {
          this.subjectsMatter = result.data as SubjectMatter[];
        }
      });
  }

  private getTestings() {
    this.requestService.getTestings().subscribe(result => {
      if (result.data !== {}) {
        this.testing = result.data as Testing[];
      }
    });
  }

  private getSemestersByStudent(cedula) {
    this.studentService.getStudentRSemesters(cedula).subscribe(result => {
      if (result.data !== []) {
        this.semesters = result.data as String[];
      }
    });
  }

  private validateSubjects(): boolean {
    let result = true;
    this.subjects.subjects.forEach((valor, indice, array) => {
      if (
        !valor.materia ||
        !valor.institucion ||
        !valor.nombrePrograma ||
        !valor.calificacion
      ) {
        result = false;
        return;
      }
    });
    return result;
  }

  private validateSubjectsHistory(): boolean {
    let result = true;
    this.subjectsHistory.subjectsHistory.forEach((valor, indice, array) => {
      if (
        !valor.codMateria ||
        !valor.materia ||
        !valor.codPrograma ||
        !valor.nombrePrograma ||
        !valor.calificacion
      ) {
        result = false;
        return;
      }
    });
    return result;
  }

  openViewRequests() {
    const cedStudent = localStorage.getItem('cedula');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { requests: this.requestsStudent , testRequets: this.testRequests, cedula: cedStudent};
    dialogConfig.width = '80%';
    const dialogRef = this.dialog.open(RequestsStudentDialogComponent, dialogConfig );
    dialogRef.afterClosed().subscribe(value => {
      if (value !== null) {
      }
    });
  }

  getValTestRequest() {
    const cedStudent = localStorage.getItem('cedula');
    this.reportService.getValTestRequests(cedStudent).subscribe(
      (result) => {
        if (result.data) {
          this.getListTestStudent();
        }
      }
    );
  }

  getListTestStudent() {
    const cedStudent = localStorage.getItem('cedula');
    this.reportService.getTestStudent(cedStudent).subscribe(
      (result) => {
        if (result.data) {
          this.testRequests = result.data as ViewRequest[];
        }
      }
    );
  }

  getRequestsStudent() {
    const cedStudent = localStorage.getItem('cedula');
    this.reportService.getRequestsStudent(cedStudent).subscribe(
      (result) => {
      if (result.data) {
        this.requestsStudent = result.data as ViewRequest[];
        }
      }
    );
  }


}
